export enum EditorMode {
  Vim = 'vim',
  Regular = 'regular',
}
